$('[data-widget="treeview"]').Treeview('init')